module.exports = __webpack_public_path__ + "static/media/plus-icon.ab54c8e9.svg";